export function mapUserData(user) {
  return {
    // ...user,
    id: user?.id,
    firstname: user?.firstname,
    lastname: user?.lastname,
    email: user?.email,
    phoneNumber: user?.phone_number,
    wishlist: {
      id: user?.wishlist?.id
    },
    totalWishlist: user?.wishlist?.items_count || 0,
    totalOrders: user?.orders?.total_count || 0,
    // user reward points
    ...rewardPointsInfo(user)
  };
}
export function rewardPointsInfo(user) {
  return {
    points: user?.reward_points?.balance?.points,
    // exchange rate (  ) the value of money that you can get from the amount of points
    moneyPoints: (user?.reward_points?.exchange_rates?.redemption?.currency_amount || 1) / (user?.reward_points?.exchange_rates?.redemption?.points || 1) * (user?.reward_points?.balance?.points || 0)
  };
}
